/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamRoleSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  instanceId: z.string().nullish(),
  isCritical: z.boolean(),
  isDefault: z.boolean(),
  lastSyncedAt: z.iso.datetime().nullish(),
  name: z.string(),
  organizationId: z.string(),
  sourceId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
